import React, { useEffect } from 'react';
import Swal from 'sweetalert2';
import Axios from 'axios'
import { getToken } from '../../../Helpers/auth-helpers';
import { validarEmail } from '../../../Helpers/utilidades-globales';

export const useIngresos = (setIsSendingMail)=>{

    const ejecutarAccionIngreso = async ({
        id_ingreso,
        method,
        url,
        tituloConfirmacion,
        textoExito,
        textoError,
        confirmButtonText,
        onSuccess
    }) => {
        if (!id_ingreso) return;

        const resultado = await Swal.fire({
            text: tituloConfirmacion,
            showCancelButton: true,
            confirmButtonText,
            cancelButtonText: 'Cancelar'
        });

        if (!resultado.isConfirmed) {
            return;
        }

        try {
            if (method === 'delete') {
                await Axios.delete(url, { data: { id_ingreso } });
            } else {
                await Axios.put(url, { id_ingreso });
            }

            await Swal.fire(textoExito, '', 'success');

            if (typeof onSuccess === 'function') {
                onSuccess();
            }
        } catch (error) {
            console.log(textoError, error);
            await Swal.fire(textoError, '', 'error');
        }
    };

    const descargarRecibo = (id_ingreso) => {
    if(!id_ingreso) return 

    const token = getToken();
    const url = `${process.env.REACT_APP_API_UAD_BASE}/documentos/recibo/false/${token}/${id_ingreso}/false`;
    window.open(url, '_blank');
};


const enviarMailRecibo = async (id_ingreso) => {
        if(!id_ingreso) return 

        const token = getToken();

        const url = `${process.env.REACT_APP_API_UAD_BASE}/documentos/datos-ingreso/enviomail/${token}/${id_ingreso}`;
            try {
                const response = await Axios.get(url);
                await manejarEnvioRecibo(response,id_ingreso)
            } catch (error) { 
                console.log("Error al buscar datos del recibo", error);

                const servidorMensaje = error.response?.data?.error || error.response?.data?.message || "Error inesperado";
                const detalle = error.response?.data?.errorId || "";

                //return await Swal.fire(error.response.data.mensaje,'','error')

                return await Swal.fire({
                    title: 'Error al buscar datos del recibo',
                    text: `${servidorMensaje}. ${detalle}`,
                    icon: 'error'
                });
            }
    };

const textoEmailSegunCaso = (caso,email)=>{
    if (caso=='iglesia'){
        if (email){
            return `(Iglesia) Confirme el correo electrónico o ingrese uno nuevo. El mail utilizado se grabara como el predeterminado para la tesorería de la iglesia.`
        }else{
            return '(Iglesia) No se encontró un correo electrónico en la base de datos. Puede ingresar uno nuevo (Se grabara como el predeterminado para la tesorería de la iglesia):'
        }
    }else if (caso=='ministro'){
        if (email){
            return '(Ministro) Confirme el correo electrónico o ingrese uno nuevo:'
        }else{
            return '(Ministro) No se encontró un correo electrónico en la base de datos. Puede ingresar uno nuevo:'
        }
    }else{
        return 'No se encontró una asignación para el ingreso (Ministro o iglesia)'
    }
} 

const textoEmailSegunCasoHTML = (caso,email)=>{
    if (caso=='iglesia'){
            return `
            <div style="text-align: center; font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;">
                ${email ? '<p style="color: #5d6d7e; font-size: 0.95rem; margin-bottom: 5px;">Confirme el correo electrónico o ingrese uno nuevo.</p>' : '<p>No se encontró un correo electrónico en la base de datos.</p>'}
                <p style="color: #85929e; font-size: 0.85rem; font-style: italic; margin-bottom: 15px;">
                    (Puede ingresar hasta 2 correos separados por coma)
                </p>
                
                <div style="background-color: #fcf3cf; border-left: 4px solid #f1c40f; padding: 10px; margin-top: 15px;">
                    <p style="color: #7e5109; font-size: 0.85rem; margin: 0; line-height: 1.4;">
                        <strong>Nota:</strong> El mail utilizado se grabará como el predeterminado para la <b>tesorería de la iglesia</b>.
                    </p>
                </div>
            </div>   
            `
    }else if (caso=='ministro'){
         return `<div style="text-align: center; font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;">
                ${email ? '<p style="color: #5d6d7e; font-size: 0.95rem; margin-bottom: 5px;">Confirme el correo electrónico o ingrese uno nuevo.</p>' : '<p>No se encontró un correo electrónico en la base de datos.</p>'}
                <p style="color: #85929e; font-size: 0.85rem; font-style: italic; margin-bottom: 15px;">
                    (Puede ingresar hasta 2 correos separados por coma)
                </p>
            </div>   
            `
    }else{
        return '<p>No se encontró una asignación para el ingreso (Ministro o iglesia)</p>'
    }
} 

const manejarEnvioRecibo = async (response,id_ingreso) => {
    const { email,id_iglesia,id_obrero } = response.data[0];

    const caso = id_iglesia ? 'iglesia' : id_obrero ? 'ministro' : 'sin-asignacion';

    //Swal.fire({ // no estaba devolviendo una promesa sino un undefined 
    return await Swal.fire({ // importante para la promesa se devuelva hacia arriba
        title: `Envío de recibo`,
        // text: !email ? 'No se encontró un correo electrónico en la base de datos. Puede ingresar uno nuevo:' :'Confirme el correo electrónico o ingrese uno nuevo:',
        //text: textoEmailSegunCaso(caso,email),
        html: textoEmailSegunCasoHTML(caso,email),
        input: 'email',
        inputValue: email, // Pre-cargamos el mail que viene del server
        showCancelButton: true,
        confirmButtonText: 'Enviar Recibo',
        cancelButtonText: 'Cancelar',
        inputValidator: (value) => {
            if (!value) {
                return 'Debes ingresar un correo electrónico';
            }
            if(value.includes(',')){
                const n_mails = value.split(',');
                if(n_mails.length>2){
                    return 'El máximo permitido son 2 emails separados por coma'
                }else{
                    for (let i = 0; i < n_mails.length; i++) {
                    
                        if(!validarEmail(n_mails[i])){
                            return `El correo electrónico ${n_mails[i]} es inválido`;
                        }
                    }
                }
            }else{
                if(!validarEmail(value)){
                    return 'El correo electrónico es inválido';
                }
            }

        }
    }).then(async (result) => {
        if (result.isConfirmed) {
            // El usuario confirmó o cambió el mail
            const correoFinal = result.value;
            
            // Mostramos el alert final con el correo elegido
           if(correoFinal.trim()!==email.trim()){
                await Swal.fire({
                    icon: 'success',
                    title: correoFinal.includes(',') ? '2 correos seleccionados' : 'Correo seleccionado',
                    text: correoFinal.includes(',') ?  `El recibo se enviará a: ${correoFinal.split(',')[0]} y a: ${correoFinal.split(',')[1]}`:`El recibo se enviará a: ${correoFinal}`,
                    showCancelButton: true,
                    confirmButtonText: 'Enviar Recibo',
                    cancelButtonText: 'Cancelar',                    
                }).then(async (result) => {
                    if (result.isConfirmed) {
                        await enviarReciboAlMail(correoFinal,id_ingreso,id_iglesia);
                    }
                })
           }else{
                await enviarReciboAlMail(correoFinal,id_ingreso,id_iglesia);
           }
            
        } else if (result.dismiss === Swal.DismissReason.cancel) {
            console.log('Envío de recibo cancelado por el usuario');
        }
    });
};

const enviarReciboAlMail = async (mail,id_ingreso,id_iglesia) => {
        const token = getToken();

        setIsSendingMail(true)
        const url = `${process.env.REACT_APP_API_UAD_BASE}/documentos/recibo/enviomail/${token}`;
                    try {
                        const response = await Axios.post(url,{
                            id_ingreso,
                            mail,
                            id_iglesia
                        });
                        
                        Swal.fire(`Recibo enviado con éxito`,'','info');
                        setIsSendingMail(false)
                    } catch (error) { 
                        console.log("Error al enviar el recibo", error);
                        //Swal.fire(`Error al enviar el recibo`,'','error')

                        const servidorMensaje = error.response?.data?.error || error.response?.data?.message || "Error inesperado";
                        const detalle = error.response?.data?.errorId || "";

                        //return await Swal.fire(error.response.data.mensaje,'','error')

                        return await Swal.fire({
                            title: 'Error al enviar el recibo',
                            text: `${servidorMensaje}. ${detalle}`,
                            icon: 'error'
                        });
                   } finally{
                           setIsSendingMail(false)
                   }

    }

    const eliminarIngreso = async (id_ingreso, onSuccess) => {
        await ejecutarAccionIngreso({
            id_ingreso,
            method: 'delete',
            url: '/api/tablasgenerales/ingresos/eliminar',
            tituloConfirmacion: '¿Está seguro de eliminar este ingreso?',
            textoExito: 'Ingreso eliminado con éxito',
            textoError: 'Error al eliminar el ingreso',
            confirmButtonText: 'Eliminar',
            onSuccess
        });
    };

    const anularIngreso = async (id_ingreso, onSuccess) => {
        await ejecutarAccionIngreso({
            id_ingreso,
            method: 'put',
            url: '/api/tablasgenerales/ingresos/anular',
            tituloConfirmacion: '¿Está seguro de anular este ingreso?',
            textoExito: 'Ingreso anulado con éxito',
            textoError: 'Error al anular el ingreso',
            confirmButtonText: 'Anular',
            onSuccess
        });
    };

    const imprimirRecibo = async (id_ingreso) => {

        // Obtenemos el token de autenticación del usuario.
        // Es necesario porque el backend valida el JWT antes de generar el PDF.
        const token = getToken();

        // Construimos la URL del endpoint que genera el PDF.
        // Esta ruta devuelve directamente el archivo PDF generado en el servidor.
        const url = `${process.env.REACT_APP_API_UAD_BASE}/documentos/recibo/true/${token}/${id_ingreso}/false`;

        // Hacemos la petición al backend usando fetch.
        // credentials: 'include' permite enviar cookies si el backend las requiere.
        // No abrimos una nueva pestaña: descargamos el archivo como datos.
        const response = await fetch(url, {
            credentials: 'include'
        });

        // Convertimos la respuesta en un Blob.
        // Un Blob es un objeto que representa datos binarios (en este caso, el PDF).
        // Aquí el PDF vive en memoria, todavía no se muestra en pantalla.
        const blob = await response.blob();

        // Creamos una URL temporal basada en el Blob.
        // Esta URL interna permite tratar el archivo en memoria como si fuera un recurso accesible.
        // No es una URL real de internet, es una referencia interna del navegador.
        const blobUrl = URL.createObjectURL(blob);

        // Creamos un iframe dinámicamente.
        // El iframe es necesario porque no podemos llamar print()
        // directamente sobre un Blob: necesitamos cargarlo en un contexto imprimible.
        const iframe = document.createElement('iframe');

        // Lo ocultamos para que el usuario no vea un documento adicional en pantalla.
        iframe.style.display = 'none';

        // Asignamos el PDF (en forma de blobUrl) como fuente del iframe.
        // Ahora el PDF se carga dentro de un documento que sí controlamos.
        iframe.src = blobUrl;

        // Insertamos el iframe en el DOM.
        // Esto es obligatorio: si no está en el DOM, no se renderiza ni se puede imprimir.
        document.body.appendChild(iframe);

        // Cuando el PDF termina de cargarse dentro del iframe,
        // podemos llamar al método print() del contentWindow.
        // Esto abre el diálogo de impresión del navegador.
        iframe.onload = () => {
            iframe.contentWindow.print();

            // Liberamos la memoria asociada al Blob.
            // Esto evita fugas de memoria si se imprime muchas veces.
            URL.revokeObjectURL(blobUrl);
        };
};

    return {
        imprimirRecibo,
        enviarMailRecibo,
        descargarRecibo,
        eliminarIngreso,
        anularIngreso
    }
}

